// This file is auto-generated by dibs-icons script
import { type FC } from 'react';

type Campaign24Props = {
    dataTn?: string;
    role?: 'img';
    ariaLabel?: string;
    ariaLabelledby?: string;
};

const Campaign24: FC<Campaign24Props> = props => {
    return (
        <svg
            style={{ display: 'block' }}
            data-tn={props.dataTn}
            role={props.role}
            aria-label={props.ariaLabel}
            aria-labelledby={props.ariaLabelledby}
            width="24"
            height="24"
        >
            <path d="M18 13v-2h4v2h-4Zm1.2 7L16 17.6l1.2-1.6 3.2 2.4-1.2 1.6Zm-2-12L16 6.4 19.2 4l1.2 1.6L17.2 8ZM5 19v-4H4c-.55 0-1.02-.196-1.413-.588A1.926 1.926 0 0 1 2 13v-2c0-.55.196-1.02.587-1.412A1.926 1.926 0 0 1 4 9h4l5-3v12l-5-3H7v4H5Zm6-4.55v-4.9L8.55 11H4v2h4.55L11 14.45Zm3 .9v-6.7c.45.4.813.887 1.088 1.463.275.575.412 1.204.412 1.887s-.137 1.313-.412 1.887A4.567 4.567 0 0 1 14 15.35Z" />
        </svg>
    );
};

export default Campaign24;
